import { createLayoutInstance } from "../../Models/Layout";
import { SettingsService } from "../Axios/Api";
import { getCurrentLanguage, getCurrentTenant } from "../Axios/axiosInstance";

export const TENANT_FAVICON_GLOBAL_KEY = "__TENANT_FAVICON__";

export const getTenantFavicon = () => {
	if (typeof window === "undefined") return null;
	return window[TENANT_FAVICON_GLOBAL_KEY] || null;
};

const setTenantFaviconGlobal = (href) => {
	if (typeof window === "undefined") return;
	window[TENANT_FAVICON_GLOBAL_KEY] = href || null;
};

const setFavicon = (href) => {
	if (!href) return;
	let link = document.querySelector('link[rel="icon"]');
	if (!link) {
		link = document.createElement('link');
		link.rel = 'icon';
		document.head.appendChild(link);
	}
	link.href = href;
	setTenantFaviconGlobal(href);
};

const setDocumentTitle = (title) => {
	if (!title) return;
	document.title = title;
};

const setCssVariables = (primaryColor, secondaryColor) => {
	const root = document.documentElement;
	if (primaryColor) {
		root.style.setProperty('--primary-color', primaryColor);
	}
	if (secondaryColor) {
		root.style.setProperty('--secondary-color', secondaryColor);
	}
};
const setHomepageId = (id) => {
	localStorage.setItem("HId", id);
}

const loadFontForLanguage = (layoutData) => {
	const language = getCurrentLanguage();
	const fonts = layoutData?.fonts || [];
	const fontEntry = fonts.find(item => item.language === language);

	const font = fontEntry?.font;
	const fontFamily = typeof font === 'string' ? font : font?.family;
	if (!fontFamily) return;

	const linkId = `layout-font-${fontFamily.replace(/\s+/g, '-').toLowerCase()}`;
	if (!document.getElementById(linkId)) {
		const link = document.createElement('link');
		link.id = linkId;
		link.rel = 'stylesheet';
		link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(fontFamily)}:wght@300;400;500;600;700&display=swap`;
		document.head.appendChild(link);
	}

	const familyValue = `"${fontFamily}", sans-serif`;
	const styleId = 'layout-font-global-style';
	let styleTag = document.getElementById(styleId);
	if (!styleTag) {
		styleTag = document.createElement('style');
		styleTag.id = styleId;
		document.head.appendChild(styleTag);
	}
	styleTag.innerHTML = `body, button, input, select, textarea { font-family: ${familyValue} !important; }`;
	document.documentElement.style.setProperty('--app-font-family', familyValue);
	document.body.style.fontFamily = familyValue;
};

export const bootstrapTenantUi = async () => {
	try {
		const tenantId = getCurrentTenant();
		const response = await SettingsService.getMinSettings(1);
		const layoutInstance = createLayoutInstance();
		const layout = await layoutInstance.load();
		loadFontForLanguage(layout);
		console.log('layout', layout);
		const result = response?.result || response;
		if (!result) return;

		setDocumentTitle(result.title);
		setFavicon(result.favIcon || result.logo);
		setCssVariables(result.primaryColor, result.secondaryColor);
		setHomepageId(result.homePageId||0	)
	} catch (_e) {
		// Silently ignore to avoid blocking app start
	}
};


